import api from './api';

const state = {
	version: {},
};

const getters = {};

const mutations = {
	setVersion(state, { version }) {
		state.version = version;
	},
};

const actions = {
	async loadVersion({ commit }) {
		const result = await api.getVersion();
		commit('setVersion', { version: result.data.version });
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
